import { HttpClient } from '../HttpClient';
/**
 * * Get Project Logs
 */

export const GetProjectLogs = async ({ ProjectID, Id }) => {
  try {
    const { data } = await HttpClient.get(`api/projectLogs/${ProjectID}/Employees/SearchCriteria`, {
      params: {
        Id,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
